import { css, Global, withTheme } from '@emotion/react'
import * as React from 'react'
const GlobalCss = withTheme(() => (
  <Global
    styles={css`
      //temp-fix : changes fixing the fidium svg image sizes these were made on attsavings resolvings same sizing issue
      .leshen-column-wrapper {
        .svg-image {
          min-width: 64px;
          max-height: 64px;
        }
      }
    `}
  />
))
export default GlobalCss
